var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-basket-number rounded-full w-6 h-6 flex justify-center items-center text-center bg-app-secondary-8-blue--medium-aquamarine leading-none font-mono font-semibold text-black"},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }